import { Fragment, ReactElement } from 'react';
import ResearchCitizenshipNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-citizenship';

const ResearchCitizenshipNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchCitizenshipNotificationsCivilStatusShared />
    </Fragment>
  );
};

ResearchCitizenshipNotificationsCivilStatusPage.displayName =
  'Research Citizenship Notifications Page component';

export default ResearchCitizenshipNotificationsCivilStatusPage;
